/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiIntegrationsDtoPaymentLinkCallbackDto
 */
export interface WebApiIntegrationsDtoPaymentLinkCallbackDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoPaymentLinkCallbackDto
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoPaymentLinkCallbackDto
     */
    paymentLinkId?: string | null;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoPaymentLinkCallbackDto interface.
 */
export function instanceOfWebApiIntegrationsDtoPaymentLinkCallbackDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoPaymentLinkCallbackDtoFromJSON(json: any): WebApiIntegrationsDtoPaymentLinkCallbackDto {
    return WebApiIntegrationsDtoPaymentLinkCallbackDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoPaymentLinkCallbackDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoPaymentLinkCallbackDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : json['status'],
        'paymentLinkId': !exists(json, 'payment_link_id') ? undefined : json['payment_link_id'],
    };
}

export function WebApiIntegrationsDtoPaymentLinkCallbackDtoToJSON(value?: WebApiIntegrationsDtoPaymentLinkCallbackDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'payment_link_id': value.paymentLinkId,
    };
}

